import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

function getVisitorId() {
  let id = localStorage.getItem("pc_visitor");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("pc_visitor", id);
  }
  return id;
}

export default function usePageTracking() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    api.post("/track", { path: pathname, visitor_id: getVisitorId() }).catch(() => {});
  }, [pathname]);
}
